"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var _jquery = require("jquery");
var _default = exports.default = {
  getActList: function getActList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeActivity/page',
      method: 'get',
      params: params
    });
  },
  getCodeList: function getCodeList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeCode/page',
      method: 'get',
      params: params
    });
  },
  getCouponList: function getCouponList(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeDetail/page',
      method: 'get',
      params: params
    });
  },
  getStoreList: function getStoreList() {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeActivity/getStoreList',
      method: 'get'
    });
  },
  addAct: function addAct(data) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeActivity/saveOrUpdate',
      method: 'post',
      data: data
    });
  },
  getDetail: function getDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeActivity/' + id,
      method: 'get'
    });
  },
  changeActStatus: function changeActStatus(data) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeActivity/updateStatus',
      method: 'post',
      data: data
    });
  },
  // 根据券第三方id获取,
  getCouponByThirdId: function getCouponByThirdId(id) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExpand/getCouponByThirdId?id=' + id,
      method: 'get'
    });
  },
  // xyCouponExchangeDetail/exportList 优惠券导出
  exportCouponData: function exportCouponData(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeDetail/exportList',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  exportCodeData: function exportCodeData(params) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExchangeCode/exportList',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  }
};